import { Applicant } from '@flatsy/types/Applications'
import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import i18n from '@flatsy/utils/translations'

import { WizardScreen } from './Type'

export const stepsName = (currentApplicant: Applicant | undefined, array: string): string => {
  switch (array) {
    case WizardScreen.bookingSelector:
      return ''
    case WizardScreen.projectRent:
      return i18n.t('your_project')
    case WizardScreen.projectSale:
      return i18n.t('your_project')
    case WizardScreen.projectPro:
      return i18n.t('your_business_project')
    case WizardScreen.applicantMain:
      return i18n.t('your_information')
    case WizardScreen.applicantCoCandidat:
      return i18n.t('your_co_signer_s_info')
    case WizardScreen.guarantor:
      return i18n.t('work_status_of_guarantor')
    case WizardScreen.professional:
      if (currentApplicant?.kind === APPLICANT_KIND.main) {
        return i18n.t('professional_situation')
      }
      if (currentApplicant?.kind === APPLICANT_KIND.co_applicant) {
        return i18n.t('work_status_of_your_co_signer')
      }
      return i18n.t('work_status_of_your_guarantor')
    case WizardScreen.needGuarantor:
      if (currentApplicant?.kind === APPLICANT_KIND.co_applicant) {
        return i18n.t('the_guarantor_of_your_co_signer')
      }
      return i18n.t('guarantor')
    case WizardScreen.verlingueGuarantor:
      return i18n.t('work_status_of_guarantor')
    case WizardScreen.closed:
      return ''
    case WizardScreen.success:
      return ''
    case WizardScreen.failed:
      return ''
    case WizardScreen.slotAlreadyTaken:
      return ''
    default:
      return ''
  }
}
